import React from "react";
import { useField } from "formik";
import { CounterpartyDropdown } from "@components/counterparty/CounterpartyDropdown";
import type { TriggerButtonProps } from "@design-system/overlay/triggerButtonProps";
import { TransferRuleDirection } from "@common/types/transactionRule";
import { TransactionRuleConditionFormSchema } from "../constants";
import { getFieldNamePrefix } from "../../utils";

interface Props {
    index: number;
    transferDirection?: TransferRuleDirection;
    controlButtonSize?: TriggerButtonProps["size"];
}

export const CounterpartyConditionForm: React.FC<Props> = ({
    index,
    transferDirection,
    controlButtonSize,
}) => {
    const fieldName = `${getFieldNamePrefix(index, transferDirection)}.counterpartyIds`;
    const [field, , helpers] =
        useField<TransactionRuleConditionFormSchema["counterpartyIds"]>(
            fieldName,
        );

    return (
        <CounterpartyDropdown
            multiple
            value={field.value ?? []}
            onValueChange={(counterpartyIds) =>
                helpers.setValue(counterpartyIds)
            }
            buttonSize={controlButtonSize ?? "md"}
        />
    );
};
